import React, { Component } from "react";
import { shanehList } from "../../../../settings";

export default class RoomRugFilterMobileShanehs extends Component {
  render() {
    return (
      <ul id="three-child-body" className="three-child-body active">
        {Object.keys(shanehList).map((shaneh) => (
          <li
            className={
              this.props.selectedShanehs.indexOf(shaneh) >= 0
                ? "three-child active"
                : "three-child"
            }
            key={"filterShanehMobile" + shaneh}
            onClick={() =>
              this.props.selectHandler(shaneh, this.props.activeFilter)
            }
          >
            <span>{shaneh}</span>
          </li>
        ))}
      </ul>
    );
  }
}
